// extracted by mini-css-extract-plugin
module.exports = {"slider__wrapper":"X_dT","slider__element":"X_dV","itemSlider":"X_dW","itemSlider__slideWrapper":"X_dX","itemSlider__pagination":"X_dY","activeSlide":"X_dZ"};